import { useMutation, MutationFunction, MutationOptions } from 'react-query';
import { login, LoginResponse, logout, refreshAccessToken } from '../../services/apiSLTP/auth';

type UseLoginMutationOptions = MutationOptions<LoginResponse, Error, { username: string; password: string }>;

export const useLoginMutation = (options?: UseLoginMutationOptions) => {
    const loginMutation: MutationFunction<LoginResponse, { username: string; password: string }> = async ({ username, password }) => {
        try {
            const response: LoginResponse = await login(username, password);
            return response;
        } catch (error) {
            throw new Error('An unexpected error occurred during login');
        }
    };

    return useMutation(loginMutation, options);
};

type UseLogoutMutationOptions = MutationOptions<LoginResponse, Error, void>;

export const useLogoutMutation = (options?: UseLogoutMutationOptions) => {
    const logoutMutation: MutationFunction<LoginResponse, void> = async () => {
        try {
            return await logout();
        } catch (error) {
            throw new Error('An unexpected error occurred during logout');
        }
    };

    return useMutation(logoutMutation, options);
};

type UseRefreshAccessTokenMutationOptions = MutationOptions<void, Error, void>;

export const useRefreshAccessTokenMutation = (options?: UseRefreshAccessTokenMutationOptions) => {
    const refreshMutation: MutationFunction<void, void> = async () => {
        try {
            return await refreshAccessToken();
        } catch (error) {
            throw new Error('An unexpected error occurred while refreshing access token');
        }
    };

    return useMutation(refreshMutation, options);
};
